import React from "react";

interface CircleCheckIconProps {
  className?: string;
  size?: number;
}

export const CircleCheckIcon = ({
  className = "",
  size = 40,
}: CircleCheckIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.5718 27.0451L28.7943 15.8226L27.2406 14.2863L17.5718 23.9659L12.6981 19.0922L11.1723 20.6284L17.5718 27.0451ZM20.0023 35.8334C17.8237 35.8334 15.7727 35.4179 13.8493 34.5868C11.926 33.7556 10.247 32.6231 8.81226 31.1892C7.37776 29.7551 6.24476 28.0767 5.41309 26.1542C4.58171 24.2317 4.16602 22.1813 4.16602 20.003C4.16602 17.813 4.58157 15.7545 5.41268 13.8276C6.24379 11.9006 7.37629 10.2245 8.81018 8.79919C10.2443 7.37402 11.9227 6.24552 13.8452 5.41385C15.7677 4.58236 17.8181 4.16669 19.9964 4.16669C22.1864 4.16669 24.2449 4.58224 26.1719 5.41335C28.0988 6.24446 29.7749 7.37238 31.2002 8.79719C32.6255 10.2219 33.7539 11.8973 34.5856 13.8234C35.417 15.7495 35.8327 17.8074 35.8327 19.9972C35.8327 22.1758 35.4171 24.2267 34.586 26.1501C33.7549 28.0734 32.627 29.7524 31.2023 31.1872C29.7775 32.6216 28.1021 33.7547 26.176 34.5863C24.2499 35.4177 22.192 35.8334 20.0023 35.8334Z"
      fill="#7F4685"
    />
  </svg>
);
